import { Icon, Link } from '@vp/swan'
import { useTranslation } from 'react-i18next'

interface Props {
  allOrdersVisible: boolean
  onShowMore: () => void
}
export const OrderSelectionLinks = ({ allOrdersVisible, onShowMore }: Props) => {
  const { t } = useTranslation()

  if (allOrdersVisible) {
    return null
  }

  return (
    <Link
      mt={5}
      onClick={onShowMore}
      data-testid="show-more-orders-link"
      skin="unstyled"
      fontSkin="body-standard-bold"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--swan-sem-space-between-icon-and-text)' }}
    >
      {t('contact_us.page.steps.issue_description.show_older_orders_link')}
      <Icon iconType="caretDown" />
    </Link>
  )
}
